import { render, staticRenderFns } from "./skyCheckbox.vue?vue&type=template&id=556fbdd9"
import script from "./skyCheckbox.vue?vue&type=script&lang=js"
export * from "./skyCheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports